import { motion } from "framer-motion"
import "./IntegrationAnimation.css"

const extractPathCoordinates = (pathString) => {
    // Match all coordinate pairs (number number) in the path string
    const coordRegex = /(\d+\.?\d*)\s+(\d+\.?\d*)/g;
    const matches = [...pathString.matchAll(coordRegex)];
    
    // Convert matches to coordinate objects
    return matches.map(match => ({
        x: parseFloat(match[1]),
        y: parseFloat(match[2])
    }));
};

const IntegrationAnimation = () => {
    // Path for rectangle with clipped corner - starts from top-left, goes clockwise
    const pathString = "M 10 15 L 10 5 L 40 5 L 50 15 L 50 60 L 10 60 L 10 30 L 30 30 L 20 40"
    const coordinates = extractPathCoordinates(pathString);

    return (
        <div style={{ position: "relative", width: "64px", height: "64px" }}>
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="64" 
                height="64"
                style={{ position: "absolute", top: 0, left: 0 }}
            >
                <motion.path
                    d={pathString}
                    fill="transparent"
                    strokeWidth="8"
                    stroke="var(--blue)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    initial={{ pathLength: 0.001, opacity: 0 }}
                    animate={{ pathLength: 1, opacity: 1 }}
                    transition={{
                        pathLength: {
                            delay: 3.5,
                            type: "tween",
                            duration: 1.2,
                            ease: "easeOut"
                        },
                        opacity: { 
                            duration: 0.01, 
                            delay: 3.5
                        }
                    }}
                />
                
                {/* Uncomment to see points at path coordinates */}
                {/* {coordinates.map((coord, index) => (
                    <circle 
                        key={index}
                        cx={coord.x}
                        cy={coord.y}
                        r="2"
                        fill="red"
                    />
                ))} */}
            </svg>
        </div>
    );
}

export default IntegrationAnimation;
